// 项目controller
import Controller from "../class/Controller";

class CollateralController extends Controller {
  constructor(ctx) {
    super(ctx);
    this.model = ctx.model.collateral;
  }

  /**
   * 设置枚举
   * @param {string} name 枚举名
   * @param {Array} value 枚举值
   */
  setEnums(name, value) {
    if (!name || typeof name !== "string") {
      throw Error(
        "ViewModel异常：project模块设置枚举需要一个String类型的枚举名"
      );
    }
    this.model.enums[name] = value;
  }

  /**
   * 获取格式化的项目列表
   * @param {Array} projects 项目列表
   */
  async getAll(collaterals, enums) {
    let result = collaterals.map(collateral => {
      return this.model.parse(collateral, enums);
    });

    return result;
  }
}

export default CollateralController;
